!
<template>
  <div class="catainer">
    <div class="catainer-center">
      <div class="catainer-center-video">
        <slot name="video"></slot>
      </div>
      <div class="catainer-center-title">
        <div style="padding: 37px 31px 21px 26px">
          <slot name="title"></slot>
          <div class="catainer-center-tabs">
            <slot name="tabs"></slot>
          </div>
        </div>
        <!-- <div class="driver"></div> -->
      </div>
    </div>
    <div class="catainer-right">
      <div>
        <div class="catainer-right-titile">
          <p>聊天互动</p>
        </div>
        <div class="catainer-right-comment">
          <comment
            :qa-id="livingStore.detail.id"
            :type="3"
            :name="livingStore.detail.title"
            :detail="livingStore.detail"
            :isLive="true"
          ></comment>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import comment from '@/components/pc-comment';

export default {
  name: '',
  inject: ['livingStore'],
  components: {
    comment
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.catainer {
  padding: 120px 140px;
  background-image: url('../../static/img/living/bgtwo.png');
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  justify-content: space-around;
  background-color: #f5f5f5;
  &-center {
    min-height: 984px;
    width: 1201px;
    background: #ffffff;
    border-radius: 9px;
    z-index: 2;
  }
  &-right {
    margin-left: 30px;
    width: 420px;
    flex-shrink: 0;
    z-index: 1;
    &-titile {
      p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
        padding: 18px 0 14px 14px;
        border-bottom: 1px solid #ebebeb;
      }
    }
    & > div {
      border-radius: 9px;
      background-color: #fff;
    }
    &-comment {
      /deep/.comment {
        min-height: 800px;
      }
    }
  }
}
.driver {
  position: relative;
  margin: 0 auto;
  width: 95%;
  height: 1px;
  background-color: #d4d4d4;
  color: #ebebeb;
}
</style>
